import { render, staticRenderFns } from "./rekoninvdb.vue?vue&type=template&id=0bba6fe2"
import script from "./rekoninvdb.vue?vue&type=script&lang=js"
export * from "./rekoninvdb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports